import { getIdToken } from "../../shared/constants/login-store";
import { API_KEY, BASE_URL } from "../../shared/constants/env";

export const onRequest = (config) => {
  if (config.baseURL.startsWith(BASE_URL)) {
    config.headers["Authorization"] = getIdToken();
    config.headers["x-api-key"] = API_KEY;
  } else {
    delete config.headers.common["Authorization"];
    delete config.headers.common["x-api-key"];
    delete config.headers.common["x-p"];
  }

  return config;
};

export const onRequestError = (error) => {
  return Promise.reject(error);
};
